import styled from 'styled-components';
import { Grid as ShrikeGrid } from '@perch-labs/shrike';
import { NAV_HEIGHT } from 'domain/style';
import { GridCell } from './grid-cell.style';
import { Grid } from './grid.style';

export const CenterGridColumn = styled(ShrikeGrid.Column).attrs({
  c4: 4,
  c8: 8,
  c12: [4, 6],
})``;

export const LeftColumnGridCell = styled(GridCell).attrs<StyleProps>(props => ({
  columns: props.columns || 6,
  small: { columns: 8 },
}))``;

export const RightColumnGridCell = styled(GridCell).attrs<StyleProps>(
  props => ({
    columnStart: props.columnStart || 7,
    columns: props.columns || 6,
    small: { columns: 8 },
  })
)``;

export const CenterColumnGridCell = styled(GridCell).attrs({
  columnStart: 3,
  columns: 8,
  small: { columnStart: 1 },
})``;

export const LeftSideOfPage = styled(GridCell).attrs({
  columns: 5,
  padding: '80px 88px 24px 0',
  small: { columns: 8, padding: '24px' },
})``;

export const BackLinkCell = styled(GridCell).attrs({
  columns: 2,
  small: { columns: 8 },
})``;

export const RightSideOfPage = styled(GridCell).attrs({
  columnStart: 8,
  columns: 5,
  padding: '80px 88px 24px',
  small: { columns: 8, padding: `48px 24px calc(48px + ${NAV_HEIGHT})` },
})`
  background-color: ${props => props.theme.colors.background.secondary};
`;

export const GridPage = styled(Grid)`
  height: calc(100vh - ${NAV_HEIGHT});
`;

export const MobileGridCell = styled(GridCell).attrs({ columns: 8 })``;
